import { currentLang } from '@/i18n';
import { cn } from '@/lib/cn';
import { formatMoney } from '@/lib/format';

/** Money in the workspace currency. Expenses are negative strings from the API; colour follows the sign. */
export function Amount({ value, currency, signed = false, className }: { value: string; currency: string; signed?: boolean; className?: string }) {
  const n = Number(value);
  return (
    <span className={cn('num', n > 0 && signed && 'text-positive', n < 0 && 'text-negative', className)}>
      {formatMoney(value, currency, currentLang(), { signed })}
    </span>
  );
}
